import Vue from 'vue'
import Router from 'vue-router'
import Menu from '@/components/AppMenu/Menu/Menu'
import Login from '@/components/AppLogin/Login/Login'

const Dashboard         = () => import('@/components/AppMenu/Dashboard/Dashboard.vue');
const Clientes        = () => import('@/components/AppMenu/Clientes/Clientes.vue');
const Clientes_Empleados    = () => import('@/components/AppMenu/Clientes/Empleados/Empleados.vue');
const Clientes_Departamentos    = () => import('@/components/AppMenu/Clientes/Departamentos/Departamentos.vue');
const Clientes_Usuarios   = () => import('@/components/AppMenu/Clientes/Usuarios/Usuarios.vue');
const Usuarios        = () => import('@/components/AppMenu/Usuarios/Usuarios.vue');
const Perfiles        = () => import('@/components/AppMenu/Perfiles/Perfiles.vue');
const Mensajes        = () => import('@/components/AppMenu/Mensajes/Mensajes.vue');
const Pruebas         = () => import('@/components/AppMenu/Pruebas/Pruebas.vue');
const Pruebas_Preguntas   = () => import('@/components/AppMenu/Pruebas/Preguntas/Preguntas.vue');
const Pruebas_Respuestas    = () => import('@/components/AppMenu/Pruebas/Respuestas/Respuestas.vue');
const Pruebas_Resultados    = () => import('@/components/AppMenu/Pruebas/Resultados/Resultados.vue');
const Aplicar_Prueba      = () => import('@/components/AppMenu/Pruebas/Aplicar_Prueba/Aplicar_Prueba.vue');
const Tests         = () => import('@/components/AppMenu/Pruebas/Tests/Tests.vue');
const Tests_Empleados   = () => import('@/components/AppMenu/Pruebas/Tests/Empleados/Empleados.vue');
const Tests_Empleados_Resultados    = () => import('@/components/AppMenu/Pruebas/Tests/Empleados/Resultados/Resultados.vue');
const Imprimir        = () => import('@/components/Imprimir/Imprimir.vue');

Vue.use(Router)

export default new Router({
    routes: [
      { path: '/', name: 'Login', component: Login },
      { path: '/imprimir', name: 'Imprimir', component: Imprimir },
      { path: '/menu', name: 'Menu', component: Menu, children:[
        { path: 'dashboard',     name: 'Dashboard',     component: Dashboard },
        { path: 'clientes',        name: 'Clientes',      component: Clientes },
        { path: 'clientes_empleados',name: 'Clientes_Empleados',component: Clientes_Empleados },
        { path: 'clientes_departamentos',name: 'Clientes_Departamentos',component: Clientes_Departamentos },
        { path: 'clientes_usuarios', name: 'Clientes_Usuarios', component: Clientes_Usuarios },
        { path: 'usuarios',        name: 'Usuarios',      component: Usuarios },
        { path: 'perfiles',        name: 'Perfiles',      component: Perfiles },
        { path: 'mensajes',        name: 'Mensajes',      component: Mensajes },
        { path: 'pruebas',       name: 'Pruebas',       component: Pruebas },
        { path: 'preguntas',       name: 'Pruebas_Preguntas', component: Pruebas_Preguntas },
        { path: 'respuestas',      name: 'Pruebas_Respuestas', component: Pruebas_Respuestas },
        { path: 'resultados',      name: 'Pruebas_Resultados', component: Pruebas_Resultados },
        { path: 'aplicar',       name: 'Aplicar_Prueba',  component: Aplicar_Prueba },
        { path: 'tests',         name: 'Tests',       component: Tests },
        { path: 'tests/empleados',   name: 'Tests_Empleados',       component: Tests_Empleados },
        { path: 'tests/empleados/resultados',  name: 'Tests_Empleados_Resultados',      component: Tests_Empleados_Resultados },
      ]}
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js